// Paletas sugeridas para elegir colores. Viven solo acá: al aplicar una se
// escriben los colores resueltos (`stackColors`), el backend no guarda cuál
// paleta fue y el tenant puede ajustar cada color después.
export const COLOR_PALETTES = [
    {
        id: "navy",
        label: "Marino",
        colors: {
            primary: "#1B2A4A",
            emphasis: "#D4AF37",
            background: "#FFFFFF",
            text: "#0F172A"
        }
    },
    {
        id: "minimal",
        label: "Minimal",
        colors: {
            primary: "#111827",
            emphasis: "#6B7280",
            background: "#FAFAFA",
            text: "#111827"
        }
    },
    {
        id: "classic",
        label: "Clásica",
        colors: {
            primary: "#7C2D12",
            emphasis: "#B45309",
            background: "#FDF6EC",
            text: "#292524"
        }
    },
    {
        id: "mono",
        label: "Blanco y negro",
        colors: {
            primary: "#262626",
            emphasis: "#737373",
            background: "#FFFFFF",
            text: "#171717"
        }
    },
    {
        id: "fresh",
        label: "Fresca",
        colors: {
            primary: "#0EA5E9",
            emphasis: "#22D3EE",
            background: "#F0F9FF",
            text: "#0C4A6E"
        }
    },
    {
        id: "vivid",
        label: "Vibrante",
        colors: {
            primary: "#C43C65",
            emphasis: "#FD951E",
            background: "#FFFFFF",
            text: "#18181B"
        }
    },
    {
        id: "coral",
        label: "Coral",
        colors: {
            primary: "#132660",
            emphasis: "#ED4F48",
            background: "#FFFFFF",
            text: "#14203D"
        }
    },
    {
        id: "bosque",
        label: "Bosque",
        colors: {
            primary: "#14532D",
            emphasis: "#84CC16",
            background: "#F7FBF4",
            text: "#152A1B"
        }
    },
    {
        id: "arena",
        label: "Arena",
        colors: {
            primary: "#8A6534",
            emphasis: "#E0A458",
            background: "#FDF8F1",
            text: "#3B2F22"
        }
    },
    {
        id: "violeta",
        label: "Violeta",
        colors: {
            primary: "#5B21B6",
            emphasis: "#A78BFA",
            background: "#FAF7FF",
            text: "#241146"
        }
    },
    {
        id: "noche",
        label: "Noche",
        colors: {
            primary: "#E2E8F0",
            emphasis: "#38BDF8",
            background: "#0F172A",
            text: "#F8FAFC"
        }
    },
    {
        id: "rosa",
        label: "Rosa",
        colors: {
            primary: "#9D174D",
            emphasis: "#F472B6",
            background: "#FFF5F8",
            text: "#3F0A22"
        }
    }
];

const PALETTE_COLOR_KEYS = ["primary", "emphasis", "background", "text"];

// Qué paleta corresponde a unos colores ya guardados, para poder
// preseleccionarla al volver al paso. Si el tenant ajustó algún color a
// mano no coincide con ninguna, y no se preselecciona nada.
export const findPaletteByColors = (stackColors) => {
    if (!stackColors) return null;
    return (
        COLOR_PALETTES.find((palette) =>
            PALETTE_COLOR_KEYS.every(
                (key) =>
                    String(stackColors[key] ?? "").toUpperCase() ===
                    palette.colors[key].toUpperCase()
            )
        ) ?? null
    );
};
